import React, { useEffect, useRef } from 'react';
import { withTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { AccordionStepsActionTypes } from '@state/features/common.types';
import useBreakpoint from '@utils/useBreakpoint';
const AccordionStep = (props) => {
    const { t } = props;
    const dispatch = useDispatch();
    const el = useRef();
    const currentBreakpoint = useBreakpoint();
    useEffect(() => {
        var _a;
        if (props.openstep === props.id) {
            (_a = el === null || el === void 0 ? void 0 : el.current) === null || _a === void 0 ? void 0 : _a.focus();
            setTimeout(() => {
                var _a, _b;
                window.scroll({
                    top: window.pageYOffset + ((_a = el === null || el === void 0 ? void 0 : el.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().top) - (((_b = el.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top) < 0 ? 48 : 0) - 176,
                    behavior: 'smooth',
                });
            }, 800);
        }
    }, [props.openstep]);
    const open = () => {
        let navigate = true;
        if (props.callback) {
            navigate = props.callback();
        }
        if (navigate) {
            dispatch({ type: AccordionStepsActionTypes.NAVIGATE_STEP, payload: props.id });
        }
    };
    let isMobile = currentBreakpoint < window.mqObj.md;
    return (React.createElement("div", { className: `accordion-step ${props.openstep === props.id ? 'active' : ''} ${props.complete ? 'step-complete' : ''}`, tabIndex: -1, id: `${props.id}Step`, ref: el },
        React.createElement("div", { className: "accordion-step-header" },
            React.createElement("div", { className: "accordion-step-header--top" },
                props.title && (props.openstep === props.id ? (React.createElement("h2", { className: "checkout-step-title font-primary-l-bold" }, props.title)) : (React.createElement("p", { className: "checkout-step-title font-primary-l-bold" }, props.title))),
                props.editable && !isMobile && React.createElement("button", { className: "cta-inline edit-button", onClick: () => { open(); } },
                    React.createElement("span", null, t('button.edit')),
                    React.createElement("span", { className: 'icon-container' },
                        React.createElement("svg", { className: `icon--edit icon--s no-stroke`, "aria-hidden": "true" },
                            React.createElement("use", { href: `#sprite-edit` }))))),
            props.description && React.createElement("div", { className: "accordion-step-header--description" },
                props.description,
                isMobile && props.editable && (React.createElement("button", { className: "cta-inline edit-button", onClick: () => { open(); } },
                    React.createElement("span", null, t('button.edit')),
                    React.createElement("span", { className: 'icon-container' },
                        React.createElement("svg", { className: `icon--edit icon--s no-stroke`, "aria-hidden": "true" },
                            React.createElement("use", { href: `#sprite-edit` }))))))),
        props.openstep === props.id && props.children));
};
export default withTranslation()(AccordionStep);
